module.exports = __webpack_public_path__ + "assets/img/coghlan.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coghlan.png
// module id = 1924
// module chunks = 0